import React, { Component } from 'react';
import {
  Redirect
} from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { ROOT_DIR } from '../../utils/Constants';

class Search extends Component {
  state = {
    keyword: '',
    validSearch: false,   
  }
  
  handleChange = (e) => {
    this.setState({
      keyword: e.currentTarget.value,
    });

  }
  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      window.location.href = ROOT_DIR + '/search/' + this.state.keyword;
    }
  }
  render(){
    //console.log(this.state);
    return(
      <div>
      <div id="keyword-search" className={this.props.searchClass}>
        <div className="input-row">
          <input type="text" placeholder="search by keyword" value={this.state.keyword} onKeyPress={this.handleKeyPress} onChange={this.handleChange}/>
          
          <NavLink to={`/search/${this.state.keyword}`}><i className="fa fa-search" aria-hidden="true"></i></NavLink>
        </div>
        
      </div>

     
      </div>
    );
  }
}
export default Search;


// WEBPACK FOOTER //
// ./src/components/blocks/Search.js